import { useContext, useEffect } from "react";
import * as olInteraction from 'ol/interaction';
import MapContext from "./mapContext";
import drawState  from '../enums/drawState';

const Interaction = ({ state, drawSource, deletePreviousPolygonCallback }) => {
  const { map } = useContext(MapContext);
  useEffect(() => {
    if (!map) return;
    let draw = null;

    //callback?
    let point = state === drawState.START || state === drawState.END || state === drawState.POINTS;

    if (point === true) {
      draw = new olInteraction.Draw({
          source: drawSource,
          type: "LineString",
          maxPoints: 2,
          condition: function(e) {
            // when the point's button is 1(leftclick), allows drawing
            if (e?.originalEvent?.buttons === 1) { 
              return true;
            } else {
              return false;
            }
          }
      });
    }
    else if (point === false) {
      draw = new olInteraction.Draw({
        source: drawSource,
        type: "Polygon",
        condition: function(e) {
          // when the point's button is 1(leftclick), allows drawing
          if (e?.originalEvent?.buttons === 1) { 
              deletePreviousPolygonCallback();
            return true;
          } else {
            return false;
          }
        }
    });
    }
    if (draw)
      map.addInteraction(draw);

    return () => {
      if (map) {
        map.removeInteraction(draw);
      }
    };
  }, [map]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};
export default Interaction;